/* eslint-disable */
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

Chart.register(ArcElement, Tooltip, Legend);

const AdsChart = () => {
  const [adsData, setAdsData] = useState([0, 0, 0]);
  const [key, setKey] = useState(0);
  const store = useSelector((state) => state.StoreReducer);
  const { t } = useTranslation();

  const platforms = useMemo(() => [
    {
      name: t("dashboard.adsChart.facebook"),
      color: "#4267B2",
      icon: "https://cdn-icons-png.flaticon.com/512/3938/3938025.png",
    },
    {
      name: t("dashboard.adsChart.tiktok"),
      color: "#000000",
      icon: "https://cdn-icons-png.flaticon.com/128/3938/3938055.png",
    },
    {
      name: t("dashboard.adsChart.instagram"),
      color: "#E1306C",
      icon: "https://cdn-icons-png.flaticon.com/128/2111/2111463.png",
    },
  ], [t]);

  useEffect(() => {
    if (store) {
      const newData = [
        store.facebookViews || 0,
        store.tiktokViews || 0,
        store.instagramViews || 0,
      ];
      setAdsData(newData);
    }
  }, [store.facebookViews, store.tiktokViews, store.instagramViews]);

  useEffect(() => {
    const handleResize = () => setKey((prevKey) => prevKey + 1);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const total = adsData.reduce((sum, value) => sum + value, 0);
  const percentages = adsData.map((value) =>
    total > 0 ? ((value / total) * 100).toFixed(1) : "0.0"
  );

  const data = {
    labels: platforms.map((p) => p.name),
    datasets: [
      {
        data: adsData,
        backgroundColor: platforms.map((p) => p.color),
        borderColor: "#FFFFFF",
        borderWidth: 2,
        circumference: 180,
        cutout: "70%",
        rotation: -90,
        borderRadius: 5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "rgba(255,255,255,0.9)",
        titleColor: "#333",
        bodyColor: "#666",
        padding: 8,
        cornerRadius: 4,
        borderColor: "rgba(0,0,0,0.1)",
        borderWidth: 1,
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw} (${(
              (context.raw / total) *
              100
            ).toFixed(1)}%)`;
          },
        },
      },
    },
  };

  return (
    <div className="bg-white dark:!bg-[#181919] col-span-1 md:col-span-2 rounded-lg shadow-sm w-full min-h-fit max-h-full dark:border dark:border-[#3c3a3d]">
      <div className="p-4 flex flex-col h-full">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-bold text-lg text-gray-800 dark:text-white">
            {t("dashboard.adsChart.title")}
          </h3>
        </div>

        <div className="flex-1 gap-y-4 flex flex-col justify-center mb-4">
          <div className="flex justify-center h-48 mb-4">
            <Doughnut key={key} data={data} options={options} />
          </div>

          <div className="grid grid-cols-3 gap-2" dir="ltr">
            {platforms.map((platform, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="rounded-lg overflow-hidden border-2 border-white w-10 h-10 bg-[#faf1ff] flex items-center justify-center shadow-sm mb-2">
                  <img
                    src={platform.icon}
                    alt={platform.name}
                    className="w-5 h-5"
                  />
                </div>
                <span className="text-sm font-medium text-gray-800">
                  {platform.name}
                </span>
                <div className="flex items-center mt-1">
                  <span
                    className="text-lg font-bold dark:text-white"
                    style={{ color: platform.color }}
                  >
                    {percentages[index]}%
                  </span>
                </div>
                <span className="text-xs text-gray-500 mt-1">
                  {adsData[index]} {t("dashboard.adsChart.visiteur")}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-auto pt-3 border-t border-gray-100 dark:border-[#3c3a3d] flex justify-between items-center">
          <span className="text-white text-sm">
            {t("dashboard.adsChart.total")}
          </span>
          <span className="bg-gray-100 dark:!bg-[#141414] text-gray-700 dark:text-gray-50 px-3 py-1 rounded-full text-sm font-medium">
            {total} {t("dashboard.adsChart.vues")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AdsChart;
